/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

// Codes defined by MSAL
export const noTokensFound = "no_tokens_found";
export const nativeAccountUnavailable = "native_account_unavailable";
export const refreshTokenExpired = "refresh_token_expired";
export const uxNotAllowed = "ux_not_allowed";

// Codes potentially returned by server
export const interactionRequired = "interaction_required";
export const consentRequired = "consent_required";
export const loginRequired = "login_required";
export const badToken = "bad_token";
